export const SKILLS = {
  Languages: ['JavaScript', 'TypeScript', 'Python', 'Java', 'Kotlin', 'C', 'Rust', 'Bash', 'GraphQL'],
  Frontend: ['React', 'Marko.js', 'HTML5', 'CSS3'],
  Backend: ['Node.js', 'Express.js', 'PostgreSQL'],
  Tools: ['AWS', 'Docker', 'Kubernetes', 'Git', 'Webpack', 'Jest', 'DataDog', 'Twilio'],
};
